/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  notifications: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        getNotificationSuccess: true,
        notifications: action.payload.notifications,
      };
    case GET_NOTIFICATIONS_FAILURE:
      return {
        getNotificationSuccess: false,
        notifications: state.notifications,
        errors: action.payload.message,
      };
    default:
      return state;
  }
}
